
import {Component, OnInit, Input} from 'ng-metadata/core';
import {BestOffer, moreOptionsUIrow, morePolicies} from "../BestOffer.interface";
import {PhysicalDeliveryMoreOptionRowService} from "./physicalDeliveryMoreOptionRow.service";

@Component({
    "inputs":[],
    "selector": 'prm-physical-delivery-more-option-row',
    templateUrl: 'components/search/fullView/ngrs/physicalDeliveryMoreOptionRow/physicalDeliveryMoreOptionRow.html',
})

export class PrmPhysicalDeliveryMoreOptionRow implements OnInit{
    @Input() policy:morePolicies;
    @Input() bestoffer:BestOffer;
    @Input() openphysicalform:object;
    @Input() showmoredeliveryoptions:Object;
    private _isAvailable: boolean=false;

    constructor (physicalDeliveryMoreOptionRowService:PhysicalDeliveryMoreOptionRowService){
        physicalDeliveryMoreOptionRowService.getMoreOption(this.policy).then((response)=>this.setOption(response));
    }

    ngOnInit(){

    }

    public isAvailable(){
        return this._isAvailable;
    }

    public getDeliveryIn(){
        return this.policy.supplyTime;
    }

    public getKeepFor(){
        return this.policy.loanPeriod;
    }

    public getRenewable(){
        return this.policy.allowRenewal;
    }

    private setOption(response: Object) {
        if(response === true){
            this._isAvailable=true;
        }

    }

    public getItRequest(){
        this.bestoffer.supplyTime=Number(this.policy.supplyTime);
        this.bestoffer.cost=this.policy.cost;
        this.bestoffer.loanPeriod=this.policy.loanPeriod;
        this.openphysicalform.openPhysicalForm=true;
        this.showmoredeliveryoptions.showMoreDeliveryOptions=false;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/physicalDeliveryMoreOptionRow/physicalDeliveryMoreOptionRow.directive.ts